import React, { useEffect } from 'react';
import { Line } from 'react-chartjs-2';


export interface BodyFatMusclesChartProps {
    weightRows: any[];
}

export const BodyFatMusclesChart = (props: BodyFatMusclesChartProps) => {

    const rows = (props.weightRows || []).filter(
        (row) => (row.muscles && row.muscles > 0) || (row.fat && row.fat > 0)
    );

    const labels = rows.map((row) => {
        const date = new Date(row.date);
        return isNaN(date.getTime()) ? row.date : date.toLocaleDateString("cs-CZ");
    });

    const musclesValues = rows.map((row) =>
        row.muscles && row.muscles > 0 ? row.muscles : null
    );
    const fatValues = rows.map((row) =>
        row.fat && row.fat > 0 ? row.fat : null
    );
    const weightValues = rows.map((row) => row.weight);

    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Svaly (kg)',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(0,0,255,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                spanGaps: true,
                data: musclesValues
            },
            {
                label: 'Tuky (kg)',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(255,0,0,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                spanGaps: true,
                data: fatValues
            }
        ]
    };


    const options = {
        tooltips: {
            callbacks: {
                label: (tooltipItem: any, chartData: any) => {
                    const dataSetLabel =
                        chartData.datasets[tooltipItem.datasetIndex].label;
                    const value = tooltipItem.yLabel;
                    const weight = weightValues[tooltipItem.index];
                    if (!weight || weight <= 0) {
                        return `${dataSetLabel}: ${value} kg`;
                    }
                    const percent = ((value / weight) * 100).toFixed(1);
                    return `${dataSetLabel}: ${value} kg (${percent} %)`;
                }
            }
        }
    };

    return <div className="lifeStyleListContainer">

        <Line height={60} data={data} options={options} />
    </div>
}